import type { TvChannel, TvShow, Vod } from '@setplex/tria-api'
import type { PayableEntity } from '~/features/payment'

import { combine } from 'effector'
import { register } from '~/core/repository'
import {
  getPaymentTvChannelMediaType,
  getPaymentTvShowMediaType,
  getPaymentVodMediaType,
  hasPriceSettings,
  isPaid,
  model as paymentModel,
} from '~/features/payment'
import { model as guestModel } from '~/features/subscriber/guest'

export const $showHowToWatchButton = combine(
  guestModel.$guest,
  (guest) => (entity: PayableEntity) =>
    entity && isPaid(entity) && hasPriceSettings(entity) && !guest
)

export const $showSignInToWatchButton = combine(
  guestModel.$guest,
  (guest) => (entity: PayableEntity) => entity && isPaid(entity) && guest
)

const $tvChannelPaymentMediaType = combine(() => (channel: TvChannel) => {
  if (!channel?.priceSettings) return null

  return getPaymentTvChannelMediaType(channel.priceSettings)
})

const $tvShowPaymentMediaType = combine(() => (show: TvShow) => {
  if (!show?.priceSettings) return null

  return getPaymentTvShowMediaType(show.priceSettings)
})

const $vodPaymentMediaType = combine(() => (vod: Vod) => {
  if (!vod?.priceSettings) return null

  return getPaymentVodMediaType(vod.priceSettings)
})

/*
 * Register payments' pipes
 */

register(paymentModel.$isFree, '|payments/isFree')
register(paymentModel.$isPaid, '|payments/isPaid')
register($showHowToWatchButton, '|payments/showHowToWatchButton')
register($showSignInToWatchButton, '|payments/showSignInToWatchButton')
register($tvChannelPaymentMediaType, '|payments/tvChannelPaymentMediaType')
register($tvShowPaymentMediaType, '|payments/tvShowPaymentMediaType')
register($vodPaymentMediaType, '|payments/vodPaymentMediaType')
